<div class="column">
  <h2>Questionari globali - Numero di questionari per tipo</h2>
  <div style="display: inline-block" style = "padding-left: 3vw; padding-top: 0vw; position: center">
    <div class = "chart-container" [ngStyle]="{'cursor': isHovered ? 'pointer' : ''}">
      <canvas id = "myChartQuestionnaires"></canvas>
    </div>
  </div>
</div>